<template>
  <li :class="formerBoxClasses">
    <div
      v-if="title || subtitle"
      :class="headerClasses"
      @click="toggle"
    >
      <div class="former-box-header-content">
        <h2
          v-if="title"
          :class="['app-h2', 'former-box-header-title', titleClass]"
        >
          {{ title }}
        </h2>

        <h4
          v-if="subtitle"
          :class="['app-h4', 'former-box-header-subtitle', subtitleClass]"
        >
          {{ subtitle }}
        </h4>
      </div>

      <span
        v-if="collapsable"
        :class="collapseClasses"
      >
        <font-awesome-icon icon="chevron-down" />
      </span>
    </div>

    <div
      v-if="visible && this.$slots.default"
      class="former-box-content"
    >
      <slot />
    </div>
  </li>
</template>

<script>
  export default {
    name: 'FormerContainer',
    props: {
      title: {
        type: String,
        default: '',
      },
      subtitle: {
        type: String,
        default: '',
      },
      titleClass: {
        type: String,
        default: '',
      },
      subtitleClass: {
        type: String,
        default: '',
      },
      collapsable: {
        type: Boolean,
        default: false,
      },
      startCollapsed: {
        type: Boolean,
        default: false,
      },
      sectionSeparator: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        visible: typeof this.startCollapsed === 'boolean' ? !this.startCollapsed : true,
      };
    },
    computed: {
      formerBoxClasses() {
        const classes = ['former-box'];

        if (!this.sectionSeparator) {
          classes.push('former-box-without-separator');
        }

        return classes;
      },
      headerClasses() {
        const classes = ['former-box-header'];

        if (this.collapsable) {
          classes.push('former-box-header-collapsable');
        }

        return classes;
      },
      collapseClasses() {
        const classes = ['former-box-collapse'];

        if (this.visible) {
          classes.push('former-box-visible');
        }

        return classes;
      },
      collapsed() {
        return this.collapsable ? this.visible : false;
      },
    },
    mounted() {
      this.emitCollapsed();
    },
    methods: {
      toggle() {
        if (!this.collapsable) {
          return;
        }

        this.visible = !this.visible;
        this.emitCollapsed();
      },
      emitCollapsed() {
        this.$emit('collapsed', !this.visible);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-box {
    padding: $gutter-big var(--product--pwa--horizontal);

    & + & {
      border-top: $spacing solid $gray-light;
    }

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter-big var(--product--pwa--horizontal);
    }
  }

  .former-box-without-separator {
    .former-box + & {
      border-top: none;
      padding-top: 0;
    }
  }

  .former-box-header {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .former-box-header-collapsable {
    cursor: pointer;
  }

  .former-box-header-content {
    flex: 1;
  }

  .settings-arrow {
    font-size: $font-big;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      display: none;
    }
  }

  .former-box-content {
    margin-top: $gutter-big;

    &:first-child {
      margin-top: 0;
    }

    &:empty {
      margin-top: 0;
    }
  }

  .former-box-collapse {
    font-size: $font-bigger;
    margin-right: -$gutter-small;
    padding: $gutter-small;
    transition: transform 0.1s;
  }

  .former-box-visible {
    transform: rotate(180deg);
  }

  .former-box-header-title {
    font-size: var(--cordel-legacy-font-size-xxl);
    font-weight: var(--cordel-legacy-font-weight-bold);
    line-height: var(--cordel-legacy-line-height-s);

    @media all and (max-width: 768px) {
      font-size: var(--cordel-legacy-font-size-xl);
    }
  }

.former-box-header-subtitle {
  color: var(--cordel-legacy-color-neutral-dark);
  font-size: var(--cordel-legacy-font-size-m);
  font-weight: var(--cordel-legacy-font-weight-regular);
  line-height: var(--cordel-legacy-line-height-l);

  @media all and (max-width: 768px) {
    font-size: var(--cordel-legacy-font-size-s);
  }
}
</style>
